import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const gender: AnswerPathTreeNode = { path: 'gender', nodeId: NodeIds.insuredGender };
